// extracted by mini-css-extract-plugin
export var copyableField = "_qg-4";
export var customerBadge = "_qg-0";
export var customerInfoTitle = "_qg-2";
export var details = "_qg-1";
export var dropdownContainer = "_qg-5";
export var dropdownImage = "_qg-6";
export var editAssigneeForm = "_qg-a";
export var editButton = "_qg-3";
export var email = "_qg-7";
export var hidden = "_qg-d";
export var input = "_qg-8";
export var saveButton = "_qg-b";
export var shopifyIcon = "_qg-c";
export var suggestionBadge = "_qg-e";
export var suggestionText = "_qg-f";
export var username = "_qg-9";